/*
 * Filename: template-list.controller.ts
 * Description: Controller for template list.
 */

import { CQAPIService } from '../../services/http-api.service';
import Cookies from 'universal-cookie';
import { CQAppConstant } from '../../app-constants';
import { CQAppStore } from '../../store/cq-app-store';
import { BaseClassDataStore } from '../../store/base-class-store';


export default class TemplateListController {
    private readonly cqAPIService: CQAPIService;
    private readonly cookie: Cookies;
    constructor() {
        this.cqAPIService = new CQAPIService();
        this.cookie = new Cookies();
    }

    public async getTemplateListState(templateListState: { templates: {}[], deployedTemplates: [], deployedTemplatesModalVisibility: boolean }) {
        try {
            await this.getTemplateList().then((templates) => {
                templateListState.templates = templates;
            });
        }
        catch(error : any){
            
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: error.error ? error.error : error.message ,
                errorStatus : error.status,
                componentName: ''
            };
            CQAppStore.error.dispatchError(errorObj);
        }
        return templateListState;
    }

    public async getBaseClasses(){
        try{
            const baseClasses = [{objects:{},defaultclassName: 'cqRecordForm'}];
            BaseClassDataStore.setBaseClassObject(baseClasses);
        }catch(error : any){
            
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorStatus : error.status,
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: error.error ? error.error : error.message ,
                componentName: ''
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    public getTemplateList() {
        const versionNumber = this.cookie.get(CQAppConstant.VERSION_NUMBER);
        return this.cqAPIService.fetchTemplates(versionNumber.replace('v','')).then((templates) => {
            return templates;
        });
    }

    public async getDeployedTemplateListState(deployedTemplateListState: { templates: {}[], deployedTemplates: [], deployedTemplatesModalVisibility: boolean }) {
        try {
            await this.fetchDeployedTemplateList().then((templates) => {
                deployedTemplateListState.deployedTemplates = templates;
                deployedTemplateListState.deployedTemplatesModalVisibility = true;

            });
        }catch (error : any) {
            
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorStatus : error.status,
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: error.error ? error.error : error.message ,
                componentName: ''
            };
            CQAppStore.error.dispatchError(errorObj);
        }

        return deployedTemplateListState;
    }

    public fetchDeployedTemplateList() {
        return this.cqAPIService.fetchDeployedTemplates().then((templates) => {
            return templates;
        });
    }


}
